import React from 'react';
import EmptyBoxSvg from "../../svg/EmptyBoxSvg";

export default function EmptyContent ({ message, moreMessage }) {
    return (
        <div className="p-4 flex flex-col justify-center items-center w-56">
            <span className="font-bold flex justify-center pb-4">
                {message}
            </span>
            <span className="flex justify-center pb-4 ">
                < EmptyBoxSvg />
            </span>
            <span className="text-gray-300 text-center text-xs leading-tight flex justify-center">
                {moreMessage}
            </span>
        </div>
    )
}